module.exports = __webpack_public_path__ + "img/complete_logo.ab855272.png";